import { api } from "@/store/api"
import { ICatalogsResponse } from "@/store/apis/catalogsAPI/catalogs.types"
import { entryCriticalRetry } from "@/store/apis/entryRetry"

export const catalogsAPI = api.injectEndpoints({
  endpoints: (build) => ({
    getCatalogs: build.query<ICatalogsResponse, void>({
      query: () => ({ url: "/catalogs", method: "GET" }),
      // Reference data is immutable for the session: fetched once at app start
      // and never evicted, so every later reader hits this same cache entry.
      // Deliberately untagged — nothing may invalidate it.
      keepUnusedDataFor: Infinity,
      extraOptions: entryCriticalRetry
    })
  })
})

export const { useGetCatalogsQuery } = catalogsAPI
